import urls from '../constants/urls'

export const RELATED_IDS_LOAD_FAILED = 'RELATED_IDS_LOAD_FAILED'
export const RELATED_IDS_LOAD_SUCCESS = 'RELATED_IDS_LOAD_SUCCESS'
export const LOADING_RELATED_IDS = 'LOADING_RELATED_IDS'

const initialState = {
  favouritedHospitalIds:  [],
  inviteRequestedHospitalIds:  [],
  failedLoading: false,
  isLoading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_RELATED_IDS:
      return {
        ...state,
        isLoading:     true,
        failedLoading: false
      }

    case RELATED_IDS_LOAD_SUCCESS:
    let payloadData = action.payload.data
      return {
        ...state,
        favouritedHospitalIds:             payloadData.data.favourited_hospital_ids,
        inviteRequestedHospitalIds:        payloadData.data.invite_requested_hospital_ids,
        readableHospitalIds:               payloadData.data.readable_hospital_ids,
        isLoading:     false,
        failedLoading: false,
        hasLoaded:     true
      }

    case RELATED_IDS_LOAD_FAILED:
      return {
        ...state,
        isLoading:     false,
        failedLoading: true
      }

    default:
      return state
  }
}

export const loadRelatedIds = (user) => (dispatch) => {
  return dispatch({
    types:   [LOADING_RELATED_IDS, RELATED_IDS_LOAD_SUCCESS, RELATED_IDS_LOAD_FAILED],
    payload: {
      request: {
        url: urls.admins.workspaces.workspaceRelatedIds(user.id)
      }
    }
  })
}
